import { IsOptional } from "class-validator";
import { Transform } from "class-transformer";
import { transformLocalized, Localized } from "@namedicinu/internal-types";

import { IsAsset, IsLocalizedMarkdown, IsLocalizedString } from "../helpers/decorators";

import { WebEntry } from "./webEntry";

export class StudyField extends WebEntry {
  public get type() {
    return "studyField" as const;
  }

  @Transform(transformLocalized)
  @IsLocalizedString()
  title: Localized<string>;
  @Transform(transformLocalized)
  @IsLocalizedMarkdown()
  description: Localized<string>;
  @IsOptional()
  @IsAsset("image")
  image: string | null;
}
